/** 华奋达支持 Win-Fn 层（无 Mac 层）的四款型号 */
export type HuafendaEquipmentLike = {
  solutionRovider?: string;
  displayname?: string;
  productName?: string;
  keyboardType?: string;
};

export function isHuafendaFnLayerSupportedDevice(
  equipment: HuafendaEquipmentLike | null | undefined
): boolean {
  if (String(equipment?.solutionRovider ?? "").trim() !== "huafenda") {
    return false;
  }
  const name = String(
    equipment?.displayname ?? equipment?.productName ?? ""
  ).trim();
  const keyboardType = String(equipment?.keyboardType ?? "").trim();

  if (name === "X87 V2") return true;
  if (name === "M98 Screen") return true;
  if (name === "SMART875") return true;
  if (name === "X98 (1K)" || keyboardType === "huafenda98") return true;

  return false;
}
